<script setup lang="ts">
import AppButton3 from '~/components/AppButton3.vue'
import type { CmsCustomComponentType } from '~/layers/cms/app/types/cmsTypes'

const props = defineProps<{
  cmsDataPath: (string | number)[]
}>()
const nazwa_komponentu = 'Index/WybrzeOpcjeDlaSiebie'
const component_default_values: CmsCustomComponentType = {
  id: { value: undefined, default_value: 'Lorem Ipsum', settingType: 'text', setting_label: 'zmien id' }
}
</script>

<template>
  <CmsCustomComponent
    v-slot="{ component_values }"
    :cms-data-path="[...props.cmsDataPath]"
    :component-name="nazwa_komponentu"
    :defaults="component_default_values"
    :open-options="true"
  >
    <div
      :id="component_values?.id?.value"
      class="py-20"
    >
      <div class="py-20 px-2xl bg-background-1 flex flex-col gap-13">
        <div class="flex flex-col gap-7.5">
          <span class="text-H2 text-Tekst">
            <CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_1']" />
          </span>
          <span class="text-H4 text-Tekst">
            <CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'text_2']" />
          </span>
        </div>
        <CmsCustomComponentList
          v-slot="{ component_values: componentListValues }"
          :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1']"
          :open-options="true"
          component-name="footer_links_list_4"
          class="min-w-5 min-h-5 flex flex-col xl:flex-row gap-11"
        >
          <div
            v-for="(item, index) in componentListValues"
            :key="JSON.stringify(item)"
            class="flex flex-col flex-1 gap-7.5"
          >
            <CmsImage
              :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1', 'component_data', index, 'image_1']"
              class="object-cover w-full h-80 xl:h-145 rounded-3xl"
            />
            <div class="flex flex-col gap-5">
              <span class="text-Paragraph text-Tekst font-bold"><CmsText :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1', 'component_data', index, 'text_3']" /></span>
              <CmsLink
                v-slot="{ link }"
                :cms-data-path="[...props.cmsDataPath, 'component_data', 'list_1', 'component_data', index, 'link']"
              >
                <AppButton3
                  :href="link?.href"
                  :target="link?.target"
                >
                  <span class="text-H3">
                    {{ link?.link_text ?? 'Lorem ipsum' }}
                  </span>
                </AppButton3>
              </CmsLink>
            </div>
          </div>
        </CmsCustomComponentList>
      </div>
    </div>
  </CmsCustomComponent>
</template>
